import React from "react"
import transcriptData from "../../transcriptData"

function SpeakToJack(props) {
    return (
        <div className="speakToJackWrapper">
            <h3>At the back of the Four Jokers gambling den I saw him. Jack. A ruthless criminal who sometimes gives me information, provided it suits his own "business" arrangements. He is the only one who would have sent me that message.</h3>
        
            <button className="standardButton fourJokersButton" onClick={props.playJack}>
                Speak To Jack
            </button>
            <h4 className="transcriptLink"><a href={transcriptData[4][1].source} target="_blank" rel="noopener noreferrer">View Transcript</a></h4>
        </div>
    )
}

export default SpeakToJack